import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import TruckRollSummary from 'truckRollComponents/TruckRollSummary';

const TruckRollPanel = (props) => {
    
    const {
        chargeActions,
        workOrderActions,
        orderCloseDetails,
        clearWorkOrderDetail,
        orderId,
        header,
        style,
        showRefreshButton,
        detailKey,
        paddingLeft,
        paddingRight,
        submitMessage,
        submitSuccess,
        submitPending,
        submitAttempted
    } = props;

    return (
        <Panel
            style={style}
            paddingLeft={paddingLeft}
            paddingRight={paddingRight}
            loading={false}
            hasDetails={true}
            orderId={orderId}
            detailKey={detailKey}
            showRefreshButton={showRefreshButton}
            clearWorkOrderDetail={clearWorkOrderDetail}
            header={header}>
            <div>
                <TruckRollSummary       
                chargeActions={chargeActions}
                workOrderActions={workOrderActions}
                orderCloseDetails={orderCloseDetails}
                workOrderId={orderId}
                submitSuccess={submitSuccess}
                displayMessage={submitMessage}
                submitPending={submitPending}
                submitAttempted={submitAttempted}/>
            </div>
        </Panel>
    );
};

TruckRollPanel.propTypes = {
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    chargeActions: PropTypes.object,
    workOrderActions: PropTypes.object,
    orderCloseDetails: PropTypes.object,
    style: PropTypes.object,
    showRefreshButton: PropTypes.bool,
    detailKey: PropTypes.string,
    paddingLeft: PropTypes.string,
    paddingRight: PropTypes.string,
    submitMessage: PropTypes.string,
    submitSuccess: PropTypes.bool,
    submitPending: PropTypes.bool,
    submitAttempted: PropTypes.bool
};

export default TruckRollPanel;



// WEBPACK FOOTER //
// ./src/components/truck-roll/TruckRollPanel.js